import { ISmukConfig } from './SmukConfig';
import { AzureAuth } from '@client/core/auth/azure/AzureAuth';

type FavoriteGroup = 'Music';

export type Token = {
	serial?: string | null;
	control?: string | null;
	uid?: string | null;
	type?: string | null;
	code?: string | null;
};

export class SmukApi {
	private _config: ISmukConfig;
	private _auth: AzureAuth;

	constructor(config: ISmukConfig, auth: AzureAuth) {
		this._config = config;
		this._auth = auth;
	}

	/**
	 * Favorites
	 */
	public async addFavorite(group: FavoriteGroup, id: string) {
		return this.request({
			url: `${this._config.api}profile/Favorite/${group}/${id}`,
			method: 'POST',
		});
	}

	public async removeFavorite(group: FavoriteGroup, id: string) {
		return this.request({
			url: `${this._config.api}profile/Favorite/${group}/${id}`,
			method: 'DELETE',
		});
	}

	public async getFavorites(group: FavoriteGroup) {
		return this.request({
			url: `${this._config.api}profile/Favorite/${group}`,
			method: 'GET',
		});
		// return this._auth.authenticatedCall(async () => {
		// 	const result = await fetch(`${this._config.api}profile/Favorite/${group}`, this.buildRequest('GET'));
		// 	return result;
		// });
	}

	/**
	 * Token/wristband registration
	 */
	public async registerToken(data: { serial: string; control: string }) {
		return this.request({
			url: `${this._config.api}profile/NfcTokenRegistration`,
			method: 'POST',
			data,
		}).then(async res => {
			if (res?.status === 204) {
				throw new Error('Invalid token registered');
			}
			return (await res?.json()) as Token;
		});
	}

	public async removeToken() {
		return this.request({
			url: `${this._config.api}profile/NfcTokenRegistration`,
			method: 'DELETE',
		});
	}

	public async getToken() {
		return this.request({
			url: `${this._config.api}profile/NfcTokenRegistration`,
			method: 'GET',
		}).then(async res => {
			if (res?.status === 204) {
				return;
			}
			return (await res?.json()) as Token;
		});
	}

	/**
	 * Default request
	 */
	private request = async ({
		url,
		data,
		...options
	}: { url: string; data?: Record<string, unknown> } & RequestInit) => {
		return this._auth.authenticatedCall(async () => {
			const body = data ? JSON.stringify(data) : undefined;

			const headers = new Headers(options?.headers);
			headers.set('Authorization', `Bearer ${this._auth.user.data.token?.access_token}`);

			if (!headers.has('X-VenueId')) headers.set('X-VenueId', '0');
			if (body) {
				headers.set('Content-Type', 'application/json');
				options.method = 'POST';
			}

			return await fetch(url, {
				body,
				...options,
				// because we use options?.headers to init Headers, we dont want them to be overwritten by ...options
				headers,
			});
		});
	};
}
